<template>
	<add-to-bag-btn
		v-if="isReleasedForCustomer"
		:item-id="selectedVariant?.id"
		:out-of-stock="selectedVariant?.outOfStock"
		:btn-class="btnClass"
	/>
	<button
		v-else
		type="button"
		disabled
		aria-label="Pending Release"
		class="bg-white !text-black pointer-events-none text-xs/[12px] h-12 border w-full border-zinc-400 min-w-40 !px-2"
	>
		<span class="uppercase font-medium" v-html="releaseDate" />
	</button>
</template>
<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { useProductStore } from '@stores'

const props = defineProps({
	btnClass: {
		type: String,
		default: '',
	},
})

const store = useProductStore()
const { selectedVariant } = storeToRefs(store)
const isReleasedForCustomer = computed(() => selectedVariant.value?.isReleasedForCustomer)
const releaseDate = computed(() => selectedVariant.value?.releaseDate)
</script>
